import { useEffect } from 'react';

import { UserState } from '@/enums/apiEnums.ts';

const usePolling = (state: UserState | undefined, cb: () => Promise<any>) => {
  useEffect(() => {
    if (
      state &&
      [UserState.STATE_ACTIVE, UserState.STATE_FROZEN].includes(state)
    ) {
      const fetch = async () => {
        await cb();
      };

      void fetch();

      const intervalId = setInterval(fetch, 60000);

      return () => clearInterval(intervalId);
    }
  }, [cb, state]);
};

export default usePolling;
